<template>
  <div class="section-label"><!--
  --><h2 class="section-label__title">
      <span class="section-label__text">{{ text }}</span>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'SectionLabel',
  props: {
    text: { type: String, default: '' }
  }
}
</script>

<style lang="scss">
.section-label {
  position: relative;
  text-align: center;
  @include use-vertical-align();

  &__title {
    display: inline-block;
    position: relative;
    height: 44px;
    color: #fafafa;
    font-size: 1.5em;
    font-weight: bold;
    letter-spacing: 0.15em;
    @include use-vertical-align();

    @include rwd($RWD_TABLET_SMALL) {
      height: 52px;
      font-size: 2.25em;
      line-height: 1em;
      letter-spacing: 0.1em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      font-size: 2.5em;
      line-height: 0.9em;
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: -9px;
      right: -9px;
      height: 50%;
      background: #e4007f;
    }
  }

  &__text {
    z-index: 1;
    position: relative;
    vertical-align: middle;
  }
}
</style>
